<template>
  <div class="activate-company">
    <div class="landing-page-wrapper">
      <div class="landing-page-content">
        <div class="activate-company__hero">
          <template v-if="emailValidCode === 1 || emailValidCode === 2">
            <h1 class="page-title">
              <svg v-if="emailValidCode === 1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-check" class="svg-inline--fa fa-circle-check fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path fill="currentColor" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM371.8 211.8l-128 128C238.3 345.3 231.2 348 224 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L224 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C382.7 183.1 382.7 200.9 371.8 211.8z"></path>
              </svg>
              <template v-if="emailValidCode === 1">
                Your email was successfully validated.
              </template>
              <template v-else>
                Your email was already validated.
              </template>
            </h1>
            <p class="page-description">
              <template v-if="emailValidCode === 1">
                In 10 seconds you will be redirected to the login page to finish your registration. If you are not redirected please click the link below.
              </template>
              <template v-else>
                In 10 seconds you will be redirected to the login page. If you are not redirected please click the link below.
              </template>
            </p>
            <div class="activate-company__hero--count-down">
              Redirecting you to login in...<span>{{ redirectCountDown }}</span>
            </div>
            <div class="activate-company__hero--actions">
              <router-link to="/login">Go to the login page</router-link>
            </div>
          </template>
          <template v-else-if="emailValidCode === 3 || emailValidCode === 4">
            <h1 class="page-title">
              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-exclamation" class="svg-inline--fa fa-circle-exclamation fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path fill="currentColor" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z"></path>
              </svg>
              Error 508 - Invalid token.<br />
              The activation token you used is invalid.
            </h1>
            <p class="page-description">
              Please insert your email address in the field below to receive an email with a new activation token.
            </p>
            <form class="activate-company__hero--form" v-on:submit.prevent="resendActivationToken()">
              <div class="landing-page-login-group"
                   :class="[{ 'active': resendActivationLinkForm.email !== '' || resendActivationLinkForm.emailFocus, 'has-error': errors.has('Email') }]">
                <label for="register-email">Email</label>
                <input id="register-email"
                       :class="[{ 'border-1-20': resendActivationLinkForm.email !== '' || resendActivationLinkForm.emailFocus }]"
                       data-lpignore="true"
                       type="email"
                       name="Email"
                       v-validate="'required'"
                       @focus="resendActivationLinkForm.emailFocus = true"
                       @blur="resendActivationLinkForm.emailFocus = false"
                       v-model="resendActivationLinkForm.email" />
              </div>
              <button type="submit">Send activation link</button>
            </form>
            <template v-if="emailValidCode === 4">
              <div class="activate-company__hero--form__error">
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-xmark" class="svg-inline--fa fa-circle-xmark fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path fill="currentColor" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM336.1 303c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.381-24.56 9.373-33.94 0L256 289.9l-47.03 47.03c-9.381 9.381-24.56 9.373-33.94 0c-9.375-9.375-9.375-24.56 0-33.94l47.03-47.03L175 208.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 222.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-47.03 47.03L336.1 303z"></path>
                </svg>
                <div>It looks like it didn't work. Please <router-link to="/contact">get in touch</router-link>.</div>
              </div>
            </template>
          </template>
          <template v-else-if="emailValidCode === 5">
            <h1 class="page-title activate-company-email-sent">
              We have sent you a new email.
            </h1>
            <p class="page-description activate-company-email-sent">
              Please <strong>follow the instructions from the email to validate your email address</strong> and move forward to the next step.<br />
              The link we have just sent you will expire in 24 hours.
            </p>
          </template>
        </div>
      </div>
      <div class="contact-cta">
        <div class="contact-cta--content">
          <div class="contact-cta--content__title">
            <h2 class="content">Do you need our help?<br /><strong>Get in touch</strong>.</h2>
          </div>
          <div class="contact-cta--content__text">
            <p class="content">
              If there's something you'd like to ask us about Clear Assured, including our COVID-19 Toolkit, or you would like to arrange a demo, please feel free to fill in the form below, drop us an email or give us a call. We look forward to hearing from you.
            </p>
          </div>
          <div class="contact-cta--actions">
            <router-link to="/callback-request">Request a callback</router-link>
            <router-link to="/contact">Message us</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api'

  export default {
    name: 'activate-company',
    props: ['token'],
    data () {
      return {
        resetInProgress: false,
        emailValidCode: 0, // 0 - needs validation, 1 - valid, 2 - validated, 3 - invalid token, 4 - invalid token and email, 5 - new activate link requested
        redirectCountDown: 10,
        resendActivationLinkForm: {
          email: '',
          emailFocus: false,
          requestInProgress: false
        }
      }
    },
    methods: {
      activateAccountByToken () {
        this.$http.post(`${api.URLS.activateCompany}${this.token}`).then((res) => {
          this.emailValidCode = res.body.code
          if (this.emailValidCode === 1 || this.emailValidCode === 2) {
            this.runCountDownRedirect()
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      resendActivationToken () {
        this.resendActivationLinkForm.requestInProgress = true
        this.$validator.validateAll().then((result) => {
          if (!result) {
            this.resendActivationLinkForm.requestInProgress = false
            return
          }
          let data = {
            email: this.resendActivationLinkForm.email
          }
          this.$http.post(api.URLS.resetCompanyActivationToken, data).then((res) => {
            this.emailValidCode = res.body.code
            this.resendActivationLinkForm.requestInProgress = false
            window.scrollTo(0, 0)
          }).catch(() => {
            this.resendActivationLinkForm.requestInProgress = false
            this.emailValidCode = 4
          })
        })
      },
      runCountDownRedirect () {
        let interval = setInterval(() => {
          this.redirectCountDown--
          if (this.redirectCountDown === 0) {
            clearInterval(interval)
            this.$router.push({name: 'login'})
          }
        }, 1000)
      }
    },
    created () {
      document.title = 'Clear Assured – activate your company account'
    },
    mounted () {
      this.activateAccountByToken()
    }
  }
</script>

<style src="@/assets/scss/main/landing-page.scss" lang="scss" scoped></style>
<style src="@/assets/scss/components/subscriptions/activate-company.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// ActivateCompany.vue?22a73156